/**
 * Default component props.
 */
const defaultProps = {
  height: '250px',
  primaryColor: '#6c63ff'
};
export default defaultProps;